// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"2a452ebf","455":"d82f00d1"}[chunkId] + ".chunk.js";
};